import axios from "axios";
import Vue from "vue";
import objectUtils from "../../util/objectUtils";
import helper from "../../util/helper";
import moment from "moment-timezone";

const getDefaultSelectedInformation = () => {
  return {
    targetType: "PERSONAL",
    sendType: "BULK_SMS",
    startDate: null,
    endDate: null,
    detail: "",
    emails: [],
    telephones: [],
    unitFilter: { unitIds: [], roleIds: [] },
    customerFilter: { educationIds: [], jobIds: [], cityIds: [], startBirthDate: null, endBirthDate: null },
    packageFilter: { packageIds: [], startPackageDate: null, endPackageDate: null },
    trainFilter: { trainIds: [], targetDate: null },
    subscriptionFilter: {
      subscriptionType: null,
      subscriptionStartDate: null,
      subscriptionEndDate: null,
      subscriptionStartStationId: null,
      subscriptionEndStationId: null,
    },
    customerType: "PACKAGE_CUSTOMER",
    subscriptionIds: [],
    discountPackageIds: [],
    schedule: { scheduleDate: null },
  };
};

export default {
  state: () => ({
    selectedInformation: getDefaultSelectedInformation(),
  }),

  mutations: {
    setSelectedInformation(state, notification) {
      Vue.set(state, "selectedInformation", notification);
    },
    setDefaultSelectedInformation(state) {
      Vue.set(state, "selectedInformation", getDefaultSelectedInformation());
    },
  },
  actions: {
    //TODO: load, update, create
    createInformation: (context, request) => {
      //TODO: Loader start
      return axios
        .post(context.getters.getMcServiceUrl + "/information-management/entity", request, {})
        .then((response) => {
          //TODO: Loader end
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    simulationInformation: (context, request) => {
      //TODO: Loader start
      return axios
        .post(context.getters.getMcServiceUrl + "/information-management/simulation", request, {})
        .then((response) => {
          //TODO: Loader end
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },
    loadInformations: (context, request) => {
      //TODO: Loader start
      return axios
        .get(context.getters.getMcServiceUrl + "/information-management/entity", {})
        .then((response) => {
          //TODO: Loader end
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },
    loadInformation: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/information-management/entity/" + request.id).then((response) => {
        if (response.data.packageFilter && response.data.packageFilter.packageType === "SUBSCRIPTION") {
          response.data.subscriptionIds = response.data.packageFilter.packageIds;
          response.data.discountPackageIds = [];
        } else if (response.data.packageFilter && response.data.packageFilter.packageType === "PACKAGE_CUSTOMER") {
          response.data.discountPackageIds = response.data.packageFilter.packageIds;
          response.data.subscriptionIds = [];
        } else {
          response.data.discountPackageIds = [];
          response.data.subscriptionIds = [];
        }
        if (!response.data.unitFilter) response.data.unitFilter = { unitIds: [], roleIds: [] };
        if (!response.data.customerFilter)
          response.data.customerFilter = { educationIds: [], jobIds: [], cityIds: [], startBirthDate: null, endBirthDate: null };
        if (!response.data.trainFilter) {
          response.data.trainFilter = { trainIds: [], targetDate: null };
        } else {
          response.data.trainFilter.targetDate = moment(response.data.trainFilter.targetDate).format("DD.MM.YYYY");
        }
        if (!response.data.packageFilter) {
          response.data.packageFilter = { packageIds: [], startPackageDate: null, endPackageDate: null };
        }
        if (response.data.customerType === "CUSTOMER") {
          response.data.customerFilter.startBirthDate = moment(response.data.customerFilter.startBirthDate).format("DD.MM.YYYY");
          response.data.customerFilter.endBirthDate = moment(response.data.customerFilter.endBirthDate).format("DD.MM.YYYY");
        } else if (response.data.customerType === "PACKAGE_CUSTOMER") {
          response.data.packageFilter.startPackageDate = moment(response.data.packageFilter.startPackageDate).format("DD.MM.YYYY");
          response.data.packageFilter.endPackageDate = moment(response.data.packageFilter.endPackageDate).format("DD.MM.YYYY");
        }
        if (response.data.sendType === "BULK_SMS" && response.data.contacts) {
          response.data.telephones = response.data.contacts;
          response.data.emails = [];
        } else if (response.data.sendType === "BULK_EMAIL" && response.data.contacts) {
          response.data.emails = response.data.contacts;
          response.data.telephones = [];
        } else if (!response.data.contacts) {
          response.data.emails = [];
          response.data.telephones = [];
          response.data.contacts = [];
        }
        if (response.data.schedule && response.data.schedule.scheduleDate) {
          response.data.schedule.scheduleDate = moment
            .utc(response.data.schedule.scheduleDate, "YYYY-MM-DD HH:mm:ss")
            .tz("Europe/Istanbul")
            .format("DD.MM.YYYY HH:mm:ss");
        } else {
          response.data.schedule = { scheduleDate: null };
        }
        // null ise boş array yap
        if (response.data.unitFilter) {
          if (!response.data.unitFilter.unitIds) {
            response.data.unitFilter.unitIds = [];
          }
          if (!response.data.unitFilter.roleIds) {
            response.data.unitFilter.roleIds = [];
          }
        }
        if (response.data.customerFilter) {
          if (!response.data.customerFilter.educationIds) {
            response.data.customerFilter.educationIds = [];
          }
          if (!response.data.customerFilter.jobIds) {
            response.data.customerFilter.jobIds = [];
          }
          if (!response.data.customerFilter.cityIds) {
            response.data.customerFilter.cityIds = [];
          }
        }
        if (response.data.trainFilter) {
          if (!response.data.trainFilter.trainIds) {
            response.data.trainFilter.trainIds = [];
          }
        }
        if (!response.data.packageFilter) {
          if (!response.data.packageFilter.packageIds) {
            response.data.packageFilter.packageIds = [];
          }
        }

        if (response.data.contacts) {
          if (!response.data.contacts.emails) {
            response.data.contacts.emails = [];
          }
          if (!response.data.contacts.telephones) {
            response.data.contacts.telephones = [];
          }
          if (!response.data.contacts.contacts) {
            response.data.contacts.contacts = [];
          }
        }

        context.commit("setSelectedInformation", response.data);
        return response;
      });
    },
    loadSelectedInformationHistory: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/information-management/history/" + request.id, {}).then((response) => {
        return response.data;
      });
    },
    deleteInformation: (context, information) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/information-management/entity/" + information.id)
        .then((response) => {
          let intents = [];
          intents.push(response.data);
          information.intents = intents;
          information.intentId = response.data.id;
          return information;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },

    publishInformation: (context, information) => {
      return axios.get(context.getters.getMcServiceUrl + "/information-management/publish/" + information.intentId).then((response) => {
        if (response.data) {
          response.data.intentId = 0;
        }
        return response.data;
      });
    },

    rejectInformation: (context, information) => {
      return axios.get(context.getters.getMcServiceUrl + "/information-management/reject/" + information.intentId).then((response) => {
        if (information.intents[0].type === "DELETE_ANNOUNCEMENT") {
          information.intents = null;
          information.intentId = 0;
        } else if (information.intents[0].type === "CREATE_ANNOUNCEMENT") {
          information.intents[0].status = "DRAFT";
        } else if (information.intents[0].type === "UPDATE_ANNOUNCEMENT") {
          information.intents[0].status = "DRAFT";
        }
        return response.data;
      });
    },

    sendToApprovalInformation: (context, information) => {
      return axios.get(context.getters.getMcServiceUrl + "/information-management/sendToApproval/" + information.intentId).then((response) => {
        if (information.intents[0].type === "CREATE_ANNOUNCEMENT") {
          information.intents[0].status = "WAITING_APPROVAL";
        } else if (information.intents[0].type === "UPDATE_ANNOUNCEMENT") {
          information.intents[0].status = "WAITING_APPROVAL";
        }
        return response.data;
      });
    },

    recallInformation: (context, information) => {
      return axios.get(context.getters.getMcServiceUrl + "/information-management/recall/" + information.intentId).then((response) => {
        helper.recallOrRejectEntity(information, "information");
        return response.data;
      });
    },

    cancelInformation: (context, information) => {
      return axios.get(context.getters.getMcServiceUrl + "/information-management/cancel/" + information.intentId).then((response) => {
        return response.data;
      });
    },
  },
  getters: {
    getSelectedInformation: (state) => {
      return state.selectedInformation;
    },
  },
};
